// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1695":"295d1650","2935":"9e2c7104","5142":"76de3f3a","6929":"9e2c7104","9564":"295d1650"}[chunkId] + ".chunk.css";
};